export const config = {
  rowSelection: true,
  columns: [
    {
      title: '产品',
      dataIndex: 'specialCode',
      width: 850,
      name: 'specialCode',
      render: 'renderProduct',
    },
    {
      title: '产品类型',
      dataIndex: 'prodTypeName',
      width: 120,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: '需求标签',
      dataIndex: 'bizTagName',
      width: 120,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: '打包模板',
      dataIndex: 'packModelName',
      name: 'packModelName',
      width: 100,
    },
    {
      title: '模板类型',
      dataIndex: 'packModelTypeName',
      name: 'packModelTypeName',
      width: 100,
    },
    {
      title: '产品分类',
      dataIndex: 'prodCateName',
      width: 100,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: '品牌',
      dataIndex: 'brandName',
      width: 120,
      ellipsis: {
        showTitle: false,
      },
    },

    {
      title: '单位',
      dataIndex: ['unitInfo', 'unitName'],
      width: 80,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: '特项代码',
      dataIndex: 'specialCode',
      name: 'specialCode',
      width: 100,
    },
    {
      title: '来源',
      dataIndex: 'sourceTypeName',
      name: 'sourceTypeName',
      width: 100,
    },
    {
      title: '物料/施工ID',
      dataIndex: 'sourceId',
      name: 'sourceId',
      width: 100,
    },
    {
      title: '物料/施工SPU编码',
      dataIndex: 'sourceCode',
      name: 'sourceCode',
      width: 100,
    },
    {
      title: '适用选材',
      dataIndex: 'applyMaterialSelectionNames',
      name: 'applyMaterialSelectionNames',
      width: 100,
      render: text => text ? text?.join(',') : '',
    },
    {
      title: '创建时间',
      dataIndex: 'createdTime',
      name: 'createdTime',
      width: 180,
      itemType: 'dateTime',
    },
    {
      title: 'SPU状态',
      dataIndex: 'enabledName',
      name: 'enabledName',
      width: 100,
      render: 'enableRender',
      fixed: 'right',
    },
    {
      title: '操作',
      key: 'action',
      width: 220,
      render: 'actionRender',
      fixed: 'right',
    },
  ],
  search: [
    {
      label: '产品名称/编码',
      name: 'excludeCombinationKeyword',
      placeholder: '按SPU/SKU/物料/施工产品名称/编码搜索',
    },
    // {
    //   label: '产品SPU_ID',
    //   name: 'id',
    // },
    // {
    //   label: '物料/施工ID',
    //   name: 'sourceId',
    // },
    // {
    //   label: '物料/施工SPU编码',
    //   name: 'sourceCode',
    // },
    {
      label: '产品类型',
      name: 'prodType',
      itemType: 'select',
      data: 'productTypeList',
      key: 'value',
      labelKey: 'label',
    },
    {
      label: '需求标签',
      name: 'bizTag',
      itemType: 'select',
      data: 'demandList',
      key: 'value',
      labelKey: 'label',
    },
    {
      label: '品牌',
      itemType: 'select',
      data: 'brandList',
      name: 'brandId',
      key: 'value',
      labelKey: 'label',
    },
    {
      label: '产品状态',
      itemType: 'select',
      name: 'enabled',
      key: 'value',
      labelKey: 'label',
      data: [
        { label: '启用', value: true },
        { label: '停用', value: false },
      ],
    },
    {
      label: '特项代码',
      name: 'specialCode',
      itemType: 'select',
      data: 'specialCodeList',
      labelKey: 'showName',
      key: 'code',
    },
    {
      label: '适用选材',
      name: 'applyMaterialSelections',
      itemType: 'select',
      data: 'applyMaterialList',
      labelKey: 'label',
      key: 'value',
      mode: 'multiple',
    },
    {
      label: '来源',
      name: 'sourceType',
      itemType: 'select',
      data: 'sourceTypeList',
      labelKey: 'label',
      key: 'value',
    }
  ],
  footer: [
    { label: '下载模板', render: 'exportRender' },
    { label: '导入产品', render: 'importRender' },
    {
      label: '列表数据全选',
      type: 'primary',
      ghost: true,
      events: ['onClick:allSelect'],
    },
    {
      label: '新增',
      //   auth: 'priceButton1',
      type: 'primary',
      events: ['onClick:onAdd'],
    },
  ],
  batchActions: [
    { label: '适用选材', danger: false, events: ['onClick:onApplyMaterialSelect'] },
    // { label: '名称定义', danger: false, events: ['onClick:onDefineName'] },
    {
      label: '批量删除',
      danger: true,
      ghost: true,
      status: ['disabled:deleteDisabled'],
      events: ['onClick:batchDelete'],
    },
    {
      label: '批量启用',
      danger: true,
      ghost: true,
      events: ['onClick:batchEnable'],
    },
    {
      label: '批量禁用',
      danger: true,
      ghost: true,
      events: ['onClick:batchDisable'],
    },
  ],
}

export const getConfig = (type = 'all') => {
  const columns = [...config.columns]
  const batchActions = [...config.batchActions]
  const footer = [...config.footer]
  switch (type){
    case 'RETAIL_LIBRARY':
      columns.splice(3, 2);
      break;
    case 'SOLUTION_LIBRARY':
      columns.splice(10, 2)
      batchActions.splice(1, 1)
      footer.splice(0, 3)
      break;
    default:
      batchActions.splice(1, 1)
      footer.splice(2, 1)
      break;
  }
  return {...config, columns, batchActions, footer}
}
